export default "__VITE_ASSET__BTqyArZ6__"